// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qy6Q7Ti1DOiKbLoPbrkj {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 2rem;
  height: 2rem;
  background-color: var(--primary-button-background);
  border-bottom-right-radius: var(--card-chevron-border-radius-bottom);
  border-top-left-radius: var(--card-chevron-border-radius);
}

.VrpNQT7NugKDTbLyAgGH {
  background-color: var(--primary-button-background-alt);
}

.tAMYUyCL7d8mwyqlrooH {
  position: absolute;
  right: 0;
  bottom: -0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 5.875rem;
  height: 1.75rem;
  padding: 0 0.5rem;
  border-radius: 0.3125rem 0 0 0.625rem
}

.tAMYUyCL7d8mwyqlrooH.whwml3HMIkakbNqPQbK9 {
    background-color: var(--card-label-color-primary);
  }

.tAMYUyCL7d8mwyqlrooH.pU_w7oKMS32tY6ORY4P3 {
    background-color: var(--card-label-color-secondary);
  }

.FcGJVNaQaCQYgA_mTKqB {
  margin-right: 0.3125rem;
}

.zvHXS_MKEOsWq7M5SytO {
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: capitalize;
  color: var(--white);
}

.QyaRlBU_7Btq0_CaZxVc.QyaRlBU_7Btq0_CaZxVc {
  position: relative;
  background-color: var(--white);
  border-radius: var(--panel-narrow-border-radius);
  border-bottom-right-radius: var(--card-chevron-border-radius-bottom);
  box-shadow: 0 0.25rem 0.75rem var(--black-012);
  transition: all 0.2s linear;
  display: block
}

.QyaRlBU_7Btq0_CaZxVc.QyaRlBU_7Btq0_CaZxVc .WZJHnExZNntZ2FippPBl {
    display: block;
    top: var(--card-chevron-top);
    right: var(--card-chevron-right);
  }

.QyaRlBU_7Btq0_CaZxVc.QyaRlBU_7Btq0_CaZxVc.vMeCaQD0eAd3wX9gYyHf {
    overflow: hidden;
    border-bottom-right-radius: var(--panel-narrow-border-radius);
  }

.QyaRlBU_7Btq0_CaZxVc.QyaRlBU_7Btq0_CaZxVc:hover {
    box-shadow: 0 0.75rem 1rem var(--black-012);
    cursor: pointer
  }

.QyaRlBU_7Btq0_CaZxVc.QyaRlBU_7Btq0_CaZxVc:hover .qy6Q7Ti1DOiKbLoPbrkj {
      background-color: var(--primary-button-hover-background);
    }

.QyaRlBU_7Btq0_CaZxVc.QyaRlBU_7Btq0_CaZxVc:hover .VrpNQT7NugKDTbLyAgGH {
      background-color: var(--primary-button-hover-background-alt);
    }

.QyaRlBU_7Btq0_CaZxVc.QyaRlBU_7Btq0_CaZxVc:hover .tAMYUyCL7d8mwyqlrooH {
      text-decoration: none;
    }

.G1ZQOgBoH7kpCsdzVkMl,
.opdOZCqqgWT_delfQaik {
  border-radius: var(--panel-narrow-border-radius);
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 0;
}

.G1ZQOgBoH7kpCsdzVkMl {
  height: 10rem;
  background-size: cover;
}

.DaBxe3vys5mCAW0crk50 {
  position: absolute;
  top: -1.5rem;
  right: 1.4375rem;
  height: calc(100% + 1.5rem);
}

.VioKt6nmLIXeS_FFyA0A {
  width: 15.0625rem;
  height: 9.75rem;
  background-size: cover;
  border-radius: var(--panel-border-radius);
}

.em8eWOwuJntch8JvdN7D {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
}

.cafad5X8EYcZLvtzgAhK {
  margin-bottom: 1rem;
}

.nTidKoPQuobLkIFddVcj {
  position: relative;
}

.opdOZCqqgWT_delfQaik {
  height: 9.75rem;
}

.Sw95b9tLzpLadx8fRgxb {
  position: absolute;
  top: -1.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 15rem;
  height: 9.6875rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: var(--panel-narrow-border-radius);
}

._qkDnWkNgQ866J0z51oO {
  box-shadow: 0 0.0625rem 0.625rem 0.0625rem rgba(61, 61, 61, 0.3);
}

.d89pEB3zpd0YE0F9_uTg {
  position: absolute;
}

.k9wMLgNYCXkcdmK2Djza {
  min-height: 6.5rem;
  margin: 1.5rem;
  overflow: hidden
}

.k9wMLgNYCXkcdmK2Djza.uPJ7Wy12iuREYZjZPEYt {
    margin-right: 12.5rem;
  }

.N73dsiLioOqc37UDbMCg {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  max-height: 2.5rem;
  color: var(--grey-400);
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  position: relative;
}

@media only screen and
  (min-width: 1280px) {
  .QyaRlBU_7Btq0_CaZxVc {
    width: 18.625rem
  }

    .QyaRlBU_7Btq0_CaZxVc.uPJ7Wy12iuREYZjZPEYt {
      width: 39.75rem;
    }

    .QyaRlBU_7Btq0_CaZxVc.eq_WKlPiOUyNrQIxbS1a {
      width: unset;
    }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .QyaRlBU_7Btq0_CaZxVc {
    width: 18rem
  }

    .QyaRlBU_7Btq0_CaZxVc.uPJ7Wy12iuREYZjZPEYt {
      width: 38rem;
    }

    .QyaRlBU_7Btq0_CaZxVc.eq_WKlPiOUyNrQIxbS1a {
      width: unset;
    }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .QyaRlBU_7Btq0_CaZxVc {
    width: 17.25rem
  }

    .QyaRlBU_7Btq0_CaZxVc.uPJ7Wy12iuREYZjZPEYt {
      width: 36rem;
    }

    .QyaRlBU_7Btq0_CaZxVc.eq_WKlPiOUyNrQIxbS1a {
      width: unset;
    }

  .DaBxe3vys5mCAW0crk50 {
    top: -1rem;
    right: 1rem;
    height: calc(100% + 1rem);
  }

  .VioKt6nmLIXeS_FFyA0A {
    width: 15.25rem;
    height: 9.875rem;
  }

  .k9wMLgNYCXkcdmK2Djza {
    min-height: 6.5rem;
    margin: 1rem;
  }

  .opdOZCqqgWT_delfQaik {
    height: 9.9375rem;
  }

  .Sw95b9tLzpLadx8fRgxb {
    top: -1rem;
    width: 15.3125rem;
    height: 9.875rem;
  }

  .tAMYUyCL7d8mwyqlrooH {
    height: 1.5rem;
    bottom: -0.75rem;
  }

  .zvHXS_MKEOsWq7M5SytO {
    font-size: 0.625rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .QyaRlBU_7Btq0_CaZxVc {
    width: 10.25rem
  }

    .QyaRlBU_7Btq0_CaZxVc.uPJ7Wy12iuREYZjZPEYt {
      width: 21.4375rem;
    }

    .QyaRlBU_7Btq0_CaZxVc.eq_WKlPiOUyNrQIxbS1a {
      width: unset;
    }

  .DaBxe3vys5mCAW0crk50 {
    top: -0.75rem;
    right: 0.75rem;
    height: calc(100% + 0.75rem);
  }

  .VioKt6nmLIXeS_FFyA0A {
    width: 9.25rem;
    height: 6rem;
  }

  .G1ZQOgBoH7kpCsdzVkMl {
    height: 6rem;
  }

  .opdOZCqqgWT_delfQaik,
  .G1ZQOgBoH7kpCsdzVkMl {
    border-radius: var(--panel-narrow-border-radius);
    border-bottom-left-radius: 0.625rem;
    border-bottom-right-radius: 0;
  }

  .k9wMLgNYCXkcdmK2Djza {
    min-height: 5.125rem;
    margin: 1rem
  }

    .k9wMLgNYCXkcdmK2Djza.uPJ7Wy12iuREYZjZPEYt {
      margin-right: 9.375rem;
    }

  .opdOZCqqgWT_delfQaik {
    height: 5.6875rem;
  }

  .Sw95b9tLzpLadx8fRgxb {
    top: -1rem;
    width: 8.75rem;
    height: 5.6875rem;
  }

  .tAMYUyCL7d8mwyqlrooH {
    height: 1.5rem;
    bottom: -0.75rem;
  }

  .zvHXS_MKEOsWq7M5SytO {
    font-size: 0.625rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductCard/ProductCard.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,oEAAoE;EACpE,yDAAyD;AAC3D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAe;EACf,eAAY;EACZ,iBAAc;EACd;AASF;;AAPE;IACE,iDAAiD;EACnD;;AAEA;IACE,mDAAmD;EACrD;;AAGF;EACE,uBAAiB;AACnB;;AAEA;EACE,kBAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gDAAgD;EAChD,oEAAoE;EACpE,8CAAuC;EACvC,2BAA2B;EAC3B;AA6BF;;AA3BE;IACE,cAAc;IACd,4BAA4B;IAC5B,gCAAgC;EAClC;;AAEA;IACE,gBAAgB;IAChB,6DAA6D;EAC/D;;AAEA;IACE,2CAAwC;IACxC;EAaF;;AAXE;MACE,wDAAwD;IAC1D;;AAEA;MACE,4DAA4D;IAC9D;;AAEA;MACE,qBAAqB;IACvB;;AAIJ;;EAEE,gDAAgD;EAChD,kCAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAU;EACV,gBAAW;EACX,2BAAyB;AAC3B;;AAEA;EACE,iBAAY;EACZ,eAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,iBAAa;EACb,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,gEAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAiB;EACjB,cAAY;EACZ;AAKF;;AAHE;IACE,qBAAmB;EACrB;;AAGF;EACE,kBAAe;EACf,mBAAmB;EACnB,kBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EACE;IACE;EASF;;IAPE;MACE,eAAY;IACd;;IAEA;MACE,YAAY;IACd;AAEJ;;AAEA;;;EACE;IACE;EASF;;IAPE;MACE,YAAY;IACd;;IAEA;MACE,YAAY;IACd;AAEJ;;AAEA;;;EACE;IACE;EASF;;IAPE;MACE,YAAY;IACd;;IAEA;MACE,YAAY;IACd;;EAGF;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,eAAY;IACZ,gBAAa;EACf;;EAEA;IACE,kBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAa;EACf;;EAEA;IACE,UAAU;IACV,iBAAY;IACZ,gBAAa;EACf;;EAEA;IACE,cAAY;IACZ,gBAAa;EACf;;EAEA;IACE,mBAAe;EACjB;AACF;;AAEA;;EACE;IACE;EASF;;IAPE;MACE,iBAAY;IACd;;IAEA;MACE,YAAY;IACd;;EAGF;IACE,aAAU;IACV,cAAW;IACX,4BAAyB;EAC3B;;EAEA;IACE,cAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,gDAAgD;IAChD,mCAA+B;IAC/B,6BAA6B;EAC/B;;EAEA;IACE,oBAAgB;IAChB;EAKF;;IAHE;MACE,sBAAmB;IACrB;;EAGF;IACE,iBAAY;EACd;;EAEA;IACE,UAAU;IACV,cAAY;IACZ,iBAAY;EACd;;EAEA;IACE,cAAY;IACZ,gBAAa;EACf;;EAEA;IACE,mBAAe;EACjB;AACF","sourcesContent":[".navButton {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 32px;\n  height: 32px;\n  background-color: var(--primary-button-background);\n  border-bottom-right-radius: var(--card-chevron-border-radius-bottom);\n  border-top-left-radius: var(--card-chevron-border-radius);\n}\n\n.navButtonAlt {\n  background-color: var(--primary-button-background-alt);\n}\n\n.label {\n  position: absolute;\n  right: 0;\n  bottom: -14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 94px;\n  height: 28px;\n  padding: 0 8px;\n  border-radius: 5px 0 0 10px;\n\n  &.primary {\n    background-color: var(--card-label-color-primary);\n  }\n\n  &.secondary {\n    background-color: var(--card-label-color-secondary);\n  }\n}\n\n.labelIcon {\n  margin-right: 5px;\n}\n\n.labelTitle {\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: capitalize;\n  color: var(--white);\n}\n\n.productCard.productCard {\n  position: relative;\n  background-color: var(--white);\n  border-radius: var(--panel-narrow-border-radius);\n  border-bottom-right-radius: var(--card-chevron-border-radius-bottom);\n  box-shadow: 0 4px 12px var(--black-012);\n  transition: all 0.2s linear;\n  display: block;\n\n  & .navButtonChevronIcon {\n    display: block;\n    top: var(--card-chevron-top);\n    right: var(--card-chevron-right);\n  }\n\n  &.withHandV1 {\n    overflow: hidden;\n    border-bottom-right-radius: var(--panel-narrow-border-radius);\n  }\n\n  &:hover {\n    box-shadow: 0 12px 16px var(--black-012);\n    cursor: pointer;\n\n    & .navButton {\n      background-color: var(--primary-button-hover-background);\n    }\n\n    & .navButtonAlt {\n      background-color: var(--primary-button-hover-background-alt);\n    }\n\n    & .label {\n      text-decoration: none;\n    }\n  }\n}\n\n.backgroundImage,\n.backgroundColor {\n  border-radius: var(--panel-narrow-border-radius);\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 0;\n}\n\n.backgroundImage {\n  height: 160px;\n  background-size: cover;\n}\n\n.cardWithHandContainer {\n  position: absolute;\n  top: -24px;\n  right: 23px;\n  height: calc(100% + 24px);\n}\n\n.cardContainer {\n  width: 241px;\n  height: 156px;\n  background-size: cover;\n  border-radius: var(--panel-border-radius);\n}\n\n.title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n}\n\n.freeLabel {\n  margin-bottom: 16px;\n}\n\n.cardWithBackgroundColorContainer {\n  position: relative;\n}\n\n.backgroundColor {\n  height: 156px;\n}\n\n.cardWithBackgroundColor {\n  position: absolute;\n  top: -24px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 240px;\n  height: 155px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border-radius: var(--panel-narrow-border-radius);\n}\n\n.cardShadow {\n  box-shadow: 0 1px 10px 1px rgba(61, 61, 61, 0.3);\n}\n\n.navButtonIcon {\n  position: absolute;\n}\n\n.infoContainer {\n  min-height: 104px;\n  margin: 24px;\n  overflow: hidden;\n\n  &.withHand {\n    margin-right: 200px;\n  }\n}\n\n.descriptionText {\n  margin-top: 8px;\n  margin-bottom: 16px;\n  max-height: 40px;\n  color: var(--grey-400);\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  overflow: hidden;\n  position: relative;\n}\n\n@media (--desktop-large) {\n  .productCard {\n    width: 298px;\n\n    &.withHand {\n      width: 636px;\n    }\n\n    &.withFreeLabel {\n      width: unset;\n    }\n  }\n}\n\n@media (--desktop-small) {\n  .productCard {\n    width: 288px;\n\n    &.withHand {\n      width: 608px;\n    }\n\n    &.withFreeLabel {\n      width: unset;\n    }\n  }\n}\n\n@media (--tablet) {\n  .productCard {\n    width: 276px;\n\n    &.withHand {\n      width: 576px;\n    }\n\n    &.withFreeLabel {\n      width: unset;\n    }\n  }\n\n  .cardWithHandContainer {\n    top: -16px;\n    right: 16px;\n    height: calc(100% + 16px);\n  }\n\n  .cardContainer {\n    width: 244px;\n    height: 158px;\n  }\n\n  .infoContainer {\n    min-height: 104px;\n    margin: 16px;\n  }\n\n  .backgroundColor {\n    height: 159px;\n  }\n\n  .cardWithBackgroundColor {\n    top: -16px;\n    width: 245px;\n    height: 158px;\n  }\n\n  .label {\n    height: 24px;\n    bottom: -12px;\n  }\n\n  .labelTitle {\n    font-size: 10px;\n  }\n}\n\n@media (--mobile) {\n  .productCard {\n    width: 164px;\n\n    &.withHand {\n      width: 343px;\n    }\n\n    &.withFreeLabel {\n      width: unset;\n    }\n  }\n\n  .cardWithHandContainer {\n    top: -12px;\n    right: 12px;\n    height: calc(100% + 12px);\n  }\n\n  .cardContainer {\n    width: 148px;\n    height: 96px;\n  }\n\n  .backgroundImage {\n    height: 96px;\n  }\n\n  .backgroundColor,\n  .backgroundImage {\n    border-radius: var(--panel-narrow-border-radius);\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 0;\n  }\n\n  .infoContainer {\n    min-height: 82px;\n    margin: 16px;\n\n    &.withHand {\n      margin-right: 150px;\n    }\n  }\n\n  .backgroundColor {\n    height: 91px;\n  }\n\n  .cardWithBackgroundColor {\n    top: -16px;\n    width: 140px;\n    height: 91px;\n  }\n\n  .label {\n    height: 24px;\n    bottom: -12px;\n  }\n\n  .labelTitle {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navButton": `qy6Q7Ti1DOiKbLoPbrkj`,
	"navButtonAlt": `VrpNQT7NugKDTbLyAgGH`,
	"label": `tAMYUyCL7d8mwyqlrooH`,
	"primary": `whwml3HMIkakbNqPQbK9`,
	"secondary": `pU_w7oKMS32tY6ORY4P3`,
	"labelIcon": `FcGJVNaQaCQYgA_mTKqB`,
	"labelTitle": `zvHXS_MKEOsWq7M5SytO`,
	"productCard": `QyaRlBU_7Btq0_CaZxVc`,
	"navButtonChevronIcon": `WZJHnExZNntZ2FippPBl`,
	"withHandV1": `vMeCaQD0eAd3wX9gYyHf`,
	"backgroundImage": `G1ZQOgBoH7kpCsdzVkMl`,
	"backgroundColor": `opdOZCqqgWT_delfQaik`,
	"cardWithHandContainer": `DaBxe3vys5mCAW0crk50`,
	"cardContainer": `VioKt6nmLIXeS_FFyA0A`,
	"title": `em8eWOwuJntch8JvdN7D`,
	"freeLabel": `cafad5X8EYcZLvtzgAhK`,
	"cardWithBackgroundColorContainer": `nTidKoPQuobLkIFddVcj`,
	"cardWithBackgroundColor": `Sw95b9tLzpLadx8fRgxb`,
	"cardShadow": `_qkDnWkNgQ866J0z51oO`,
	"navButtonIcon": `d89pEB3zpd0YE0F9_uTg`,
	"infoContainer": `k9wMLgNYCXkcdmK2Djza`,
	"withHand": `uPJ7Wy12iuREYZjZPEYt`,
	"descriptionText": `N73dsiLioOqc37UDbMCg`,
	"withFreeLabel": `eq_WKlPiOUyNrQIxbS1a`
};
export default ___CSS_LOADER_EXPORT___;
